var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "approve-application-modal",
        title: "Please confirm",
        centered: "",
        "ok-title": "Confirm",
        "ok-variant": "success",
      },
      on: { ok: _vm.confirmApprove },
    },
    [
      _c("h4", [_vm._v("You are going to approve this application")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Facility permissions" } },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { value: true, "unchecked-value": false },
              model: {
                value: _vm.formData.is_to_buy,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "is_to_buy", $$v)
                },
                expression: "formData.is_to_buy",
              },
            },
            [
              _vm._v("\n      Permit "),
              _c("strong", [_vm._v("Purchase")]),
              _vm._v(" operations\n    "),
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              attrs: { value: true, "unchecked-value": false },
              model: {
                value: _vm.formData.is_to_sell,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "is_to_sell", $$v)
                },
                expression: "formData.is_to_sell",
              },
            },
            [
              _vm._v("\n      Permit "),
              _c("strong", [_vm._v("Sale")]),
              _vm._v(" operations\n    "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }